const doc = [({"en":({"js":({"admin":({"photo_colors":({"select":({"choose_photo_color":"Choose photo color"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;